module.exports = __webpack_public_path__ + "img/feels_like.48bf8425.svg";